var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes.root,on:{"click":_vm.onClick}},[(_vm.icon)?_c(_vm.icon + '-icon',{tag:"component",attrs:{"width":_vm.iconSize || 14,"height":_vm.iconSize || 14,"color":_vm.colors.icon}}):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }